import React from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import { DashboardListBannerView } from './DashboardListBanner.view';

interface DashboardListBannerProps {
  showBanner: boolean;
}

const BANNER_TITLE = 'Upgrade your workflow with QAlity Plus';
const BANNER_ITEMS: Array<string> = [
  'Manage test cases easily - import, export, clone, and add in bulk to the Test Cycle.',
  'Keep your team on track with an advanced dashboard, allowing you to view recent Test Cycles and create new ones.',
  'Enjoy the dark mode version of the app.',
  'Benefit from our dedicated support with a 24h guaranteed response time.',
  'Take care of your safety with a Cloud Fortified app.',
];

const PRIMARY_ACTION_TEXT = 'Try it free';
const SECONDARY_ACTION_TEXT = 'Learn more';

export const DashboardListBanner: React.FC<DashboardListBannerProps> = ({
  showBanner,
}: DashboardListBannerProps) => {
  const urlService = StorageOfUniqueServices.get('URLService');

  const bannerImagePath = urlService.getQAlityPlusImage();
  const primaryActionLink = urlService.getQalityPlusMarketplaceUrl();
  const secondaryActionLink = urlService.getQalityVersionsComparisonUrl();

  return (
    <>
      {showBanner && (
        <DashboardListBannerView
          title={BANNER_TITLE}
          items={BANNER_ITEMS}
          primaryAction={{
            text: PRIMARY_ACTION_TEXT,
            link: primaryActionLink,
          }}
          secondaryAction={{
            text: SECONDARY_ACTION_TEXT,
            link: secondaryActionLink,
          }}
          bannerImagePath={bannerImagePath}
        />
      )}
    </>
  );
};
